import React, { useState, useContext } from 'react';
import { SymptomDetailsContext } from '../../../utilities/context';
import { Box } from '@mui/material';
import ExtraFormQuestionsModal from './extra form questions/ExtraFormQuestionsModal';


function NonTwrRefOption(props) {
  const [pathwaySelected, setPathwaySelected]=useState(false)
  const {nonRdc,setNonRdc} = useContext(SymptomDetailsContext )
  const [modalOpen, setModalOpen] = useState(false)
  const clickFunction=()=>{
    let newNonRdc=nonRdc  
      
    setPathwaySelected(pathwaySelected ===true ? false : true)
    if (!pathwaySelected)
      {
      setModalOpen(true)
     newNonRdc.push(props.readablePath)
      }
    else
      {
        for( let index = 0; index < nonRdc.length; index ++)
          { 
          
          if ( newNonRdc[index] === props.readablePath) 
            { 
              newNonRdc.splice(index, 1); 
            }
          }
      }
    setNonRdc(newNonRdc)
    }
    
  return (  
  <Box>
    
      <div id="twrOption">
        Refer to {props.readablePath} (Not RDC) 
        < button id={props.pathway} onClick={clickFunction}>{(pathwaySelected ? "Remove from Order" : "Add to Order")} </button> </div>

        <Box>
       <ExtraFormQuestionsModal path={props.pathway} readablePath={props.readablePath} modalOpen={modalOpen} setModalOpen={setModalOpen} pathwayType={"nonRdc"}/>
       </Box>
  </Box>
      );
  }
  
  

export default NonTwrRefOption;